// ======================================================================
// File Name       : RegisterMessageUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import TableHead from '../TableHead';
import { VALIDATE_TYPE } from '../../constants/index';

class RegisterMessageUserList extends React.Component {
  render() {
    const {
      edittingUsers,
      showModal,
      removeUserFromList,
      isConfirm,
      formValues,
      removeAllUserFromList,
    } = this.props;
    let thead = [
      { title: 'ログインID', sortBy: null },
      { title: 'ユーザー名', sortBy: null },
      { title: '所属グループ名', sortBy: null },
      { title: '操作', sortBy: null, width: 120 },
    ];
    if (isConfirm) {
      thead = [
        { title: 'ログインID', sortBy: null },
        { title: 'ユーザー名', sortBy: null },
        { title: '所属グループ名', sortBy: null },
      ];
    }
    let tbody = null;
    let isNotAddUser = false;
    if (formValues && formValues.messageOperationFlag) {
      isNotAddUser = true;
    }
    if (edittingUsers && edittingUsers.allSecernIds && edittingUsers.allSecernIds.length) {
      tbody = edittingUsers.allSecernIds.map((userSecernId, index) => {
        const user = edittingUsers.bySecernIds[userSecernId];
        if (!user) {
          return null;
        }
        return (
          <tr key={index}>
            <td className="text-left">{user.loginId}</td>
            <td className="text-left">{user.userName}</td>
            <td className="text-left">{user.groupNames}</td>
            {!isConfirm && <td className="text-center">
              <i
                className="bi bi-trash cursor_pointer"
                onClick={(e) => {
                  e.preventDefault();
                  removeUserFromList(userSecernId);
                }}
              />
            </td>}
          </tr>
        );
      });
    }
    return (
      <div>
        {!isConfirm ? (
          <Form.Group className="margin-top-20">
            <Col sm={12}>
              <Col sm={3} style={{ marginTop: '20px', paddingLeft: '10px' }} >
                <p> 送信先ユーザー一覧</p>
              </Col>
              <Col sm={5} className="text-center margin-bottom-15">
                <Button variant="primary" className="btn-96 margin-top-20" onClick={showModal} disabled={isNotAddUser}>
                  追加
                </Button>
              </Col>
              <Col sm={4} className="text-right padding-clear margin-top-20">
                <Button variant="default" className="btn btn-default btn-96" onClick={removeAllUserFromList}>ユーザー一括削除</Button>
              </Col>
            </Col>
            <Col sm={12}>
              <RenderField
                name="destinationUserList"
                type="requiredarray"
                validates={ isNotAddUser ? [] : [
                  VALIDATE_TYPE.REQUIRED_ARRAY,
                ]}
                label="送信先ユーザー"
                keyArrayToCheck="edittingUserList"
              />
            </Col>
          </Form.Group>
        ) : (
          <Form.Group className="margin-top-20">
            <Col
              sm={3}
              style={{ marginBottom: '10px' }}
              className="padding-left-clear"
            >
              <p> 送信先ユーザー一覧</p>
            </Col>
          </Form.Group>
        )}
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </div>
    );
  }
}

export default RegisterMessageUserList;
